import { inject, Injectable } from '@angular/core';
import { NotificationsActions } from '@dice/app/store/notifications/notifications.actions';
import { ProfileNotification } from '@dice/app/types/notification.types';
import { RxStomp } from '@stomp/rx-stomp';
import { IMessage } from '@stomp/stompjs';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NotificationsApiService {
  private cookieService = inject(CookieService);

  watchUserNotification(
    action: NotificationsActions.InitUserNotifications,
    stomp: RxStomp,
  ): Observable<ProfileNotification> {
    return stomp.watch(`/user/${action.profile.userId.toUpperCase()}/queue/updates`).pipe(
      map((res: IMessage) => {
        return JSON.parse(res.body) as ProfileNotification;
      }),
    );
  }
}
